import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";
import {rankingLastYear} from "../constants/ranking";

import expertImage from "../images/marek-wielgo.png";

export function OfferRankingExpert() {
    return (
        <div className={offerRankingExpert}>
            <div className={wrap}>
                <div className={expertMessage}>
                    <Text variant="headline_2" as="h3">
                        Okiem eksperta
                    </Text>
                    <Text className={expertText}>
                        Preferencje kupujących kształtują przede wszystkim ich możliwości finansowe, zwłaszcza w kontekście lokalizacji i metrażu mieszkań.
                        Zarówno na rynku pierwotnym, jak i wtórnym, niezmiennie największym zainteresowaniem cieszą się lokale dwupokojowe. Dla większości
                        poszukujących idealnego lokum kluczowe jest położenie w dobrze skomunikowanej i bezpiecznej okolicy, z łatwym dostępem do sklepów,
                        szkół, przedszkoli, przychodni oraz terenów zielonych i rekreacyjnych. Coraz większą rolę odgrywają także udogodnienia, takie jak
                        miejsca parkingowe, rowerownie czy komórki lokatorskie. Jednak to koszty eksploatacji często decydują o ostatecznym wyborze.
                        Nieodłącznym elementem atrakcyjnego mieszkania jest balkon lub taras, a jeszcze większym atutem – prywatny ogródek. Trendy te
                        potwierdzają wyniki <b>Rankingu Inwestycji {rankingLastYear}</b>, w którym osiedla cieszące się największą popularnością to te
                        spełniające kluczowe oczekiwania nabywców: atrakcyjna lokalizacja, dostęp do infrastruktury miejskiej i nowoczesne rozwiązania
                        podnoszące komfort życia.
                    </Text>
                </div>
                <div className={expert}>
                    <Image alt="Marek Wielgo" width="192px" height="192px" src={expertImage} className={expertImageStyle} />
                    <div className={expertDescription}>
                        <Text variant="headline_6" as="p" className={expertDescriptionAlign}>
                            Marek Wielgo
                        </Text>
                        <Text variant="info_txt_1" className={expertDescriptionAlign}>
                            {concatWithBrandName("Ekspert")}
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    );
}

const offerRankingExpert = css({
    backgroundColor: "var(--colors-gray-200)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
});

const wrap = css({
    maxWidth: "936px",
    py: 4,
    px: 3,
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: 4,

    md: {
        flexDirection: "row",
        py: 8,
        px: 3
    }
});

const expertMessage = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,

    md: {
        order: 1
    }
});

const expertText = css({
    fontStyle: "italic"
});

const expert = css({
    display: "flex",
    gap: 2,
    alignItems: "center",
    justifyContent: "center",

    md: {
        flexDirection: "column",
        gap: 3,
        order: 0
    }
});

const expertImageStyle = css({
    flex: "0 0 auto",
    width: "calc(var(--globals-baseUnit) * 12)",
    height: "calc(var(--globals-baseUnit) * 12)",
    borderRadius: "50%",
    "& > img": {
        width: "100%",
        height: "100%"
    },

    md: {
        width: "calc(var(--globals-baseUnit) * 24)",
        height: "calc(var(--globals-baseUnit) * 24)"
    }
});

const expertDescription = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    maxWidth: "244px"
});

const expertDescriptionAlign = css({
    md: {
        textAlign: "center"
    }
});
import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";
import {rankingLastYear} from "../constants/ranking";

import expertImage from "../images/marek-wielgo.png";

export function OfferRankingExpert() {
    return (
        <div className={offerRankingExpert}>
            <div className={wrap}>
                <div className={expertMessage}>
                    <Text variant="headline_2" as="h3">
                        Okiem eksperta
                    </Text>
                    <Text className={expertText}>
                        Preferencje kupujących kształtują przede wszystkim ich możliwości finansowe, zwłaszcza w kontekście lokalizacji i metrażu mieszkań.
                        Zarówno na rynku pierwotnym, jak i wtórnym, niezmiennie największym zainteresowaniem cieszą się lokale dwupokojowe. Dla większości
                        poszukujących idealnego lokum kluczowe jest położenie w dobrze skomunikowanej i bezpiecznej okolicy, z łatwym dostępem do sklepów,
                        szkół, przedszkoli, przychodni oraz terenów zielonych i rekreacyjnych. Coraz większą rolę odgrywają także udogodnienia, takie jak
                        miejsca parkingowe, rowerownie czy komórki lokatorskie. Jednak to koszty eksploatacji często decydują o ostatecznym wyborze.
                        Nieodłącznym elementem atrakcyjnego mieszkania jest balkon lub taras, a jeszcze większym atutem – prywatny ogródek. Trendy te
                        potwierdzają wyniki <b>Rankingu Inwestycji {rankingLastYear}</b>, w którym osiedla cieszące się największą popularnością to te
                        spełniające kluczowe oczekiwania nabywców: atrakcyjna lokalizacja, dostęp do infrastruktury miejskiej i nowoczesne rozwiązania
                        podnoszące komfort życia.
                    </Text>
                </div>
                <div className={expert}>
                    <Image alt="Marek Wielgo" width="192px" height="192px" src={expertImage} className={expertImageStyle} />
                    <div className={expertDescription}>
                        <Text variant="headline_6" as="p" className={expertDescriptionAlign}>
                            Marek Wielgo
                        </Text>
                        <Text variant="info_txt_1" className={expertDescriptionAlign}>
                            {concatWithBrandName("Ekspert")}
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    );
}

const offerRankingExpert = css({
    backgroundColor: "var(--colors-gray-200)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
});

const wrap = css({
    maxWidth: "936px",
    py: 4,
    px: 3,
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: 4,

    md: {
        flexDirection: "row",
        py: 8,
        px: 3
    }
});

const expertMessage = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,

    md: {
        order: 1
    }
});

const expertText = css({
    fontStyle: "italic"
});

const expert = css({
    display: "flex",
    gap: 2,
    alignItems: "center",
    justifyContent: "center",

    md: {
        flexDirection: "column",
        gap: 3,
        order: 0
    }
});

const expertImageStyle = css({
    flex: "0 0 auto",
    width: "calc(var(--globals-baseUnit) * 12)",
    height: "calc(var(--globals-baseUnit) * 12)",
    borderRadius: "50%",
    "& > img": {
        width: "100%",
        height: "100%"
    },

    md: {
        width: "calc(var(--globals-baseUnit) * 24)",
        height: "calc(var(--globals-baseUnit) * 24)"
    }
});

const expertDescription = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    maxWidth: "244px"
});

const expertDescriptionAlign = css({
    md: {
        textAlign: "center"
    }
});
